import React, { useContext, useState } from 'react';
import './Payment.css';
import axios from 'axios';
import { ShopContext } from '../../Context/ShopContext';
import { useNavigate } from 'react-router-dom';

const Payment = () => {
  const { CartItems, all_product, getTotalCartAmount } = useContext(ShopContext);
  const navigate = useNavigate();
  const [cardName, setCardName] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const totalCartAmount = getTotalCartAmount(); // استخدام اسم أوضح

  const handlePay = async () => {
    const orderItems = Object.entries(CartItems).flatMap(([productId, sizes]) =>
      Object.entries(sizes)
        .filter(([size, quantity]) => quantity > 0)
        .map(([size, quantity]) => {
          const product = all_product.find(p => p.id === Number(productId));
          return {
            id: product.id,
            name: product.name,
            image: product.image || product.image_urls?.[0],
            price: product.new_price,
            quantity,
            size,
          };
        })
    );

    const order = {
      name: cardName,
      cardNumber: cardNumber,
      total: totalCartAmount,
      items: orderItems,
      date: new Date()
    };

    try {
      await axios.post('http://localhost:4000/payment', order);
      alert('Payment successful!');
      navigate('/orders'); // توجيه إلى صفحة Orders بعد الدفع
    } catch (err) {
      console.error(err);
      alert('Payment failed.');
    }
  };

  return (
    <div className="payment-container">
      <h2>Payment</h2>
      <div className="payment-content">
        <div className="payment-left">
          <div className="payment-format-main">
            <p>Products</p>
            <p>Title</p>
            <p>Price</p>
            <p>Quantity</p>
            <p>Total</p>
          </div>
          <hr />
          {all_product.map((e) => {
            const sizes = CartItems[e.id];
            const hasItems = Object.values(sizes).some(quantity => quantity > 0);
            if (hasItems) {
              const itemSubtotal = e.new_price * Object.values(sizes).reduce((sum, q) => sum + q, 0);
              return (
                <div key={e.id}>
                  <div className="payment-format">
                    <img
                    src={e.image_urls?.[0] || e.image || 'https://via.placeholder.com/300'}
                    alt={e.name}className="payment-product-icon" />
                    <p>{e.name}</p>
                    <p>${e.new_price}</p>
                    <div>
                      {Object.entries(sizes).map(([size, quantity]) => {
                        if (quantity > 0) {
                          return (
                            <p key={size}>{quantity} x {size}</p>
                          );
                        }
                        return null;
                      })}
                    </div>
                    <p>${itemSubtotal.toFixed(2)}</p>
                  </div>
                  <div className="payment-subtotal">
                    <p>Subtotal: ${itemSubtotal.toFixed(2)}</p>
                  </div>
                  <hr />
                </div>
              );
            }
            return null;
          })}
          {/* إزالة قسم payment-total العام */}
          <label>Cardholder Name</label>
          <input type="text" value={cardName} onChange={(e) => setCardName(e.target.value)} />
          <label>Card Number</label>
          <input type="text" value={cardNumber} onChange={(e) => setCardNumber(e.target.value)} />
          <button onClick={handlePay}>Pay ${totalCartAmount.toFixed(2)}</button>
        </div>
      </div>
    </div>
  );
};

export default Payment;


